import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/instalar-certificado-ssl.svg'


const _hoisted_1 = { class: "content-password-view" }
const _hoisted_2 = { class: "d-flex flex-row row" }
const _hoisted_3 = { class: "col-12 col-lg-6" }
const _hoisted_4 = { class: "input-create-user" }
const _hoisted_5 = { class: "input-label mb-1" }
const _hoisted_6 = { class: "input-create-password col-12" }
const _hoisted_7 = { class: "input-label mb-1" }
const _hoisted_8 = { class: "d-flex justify-content-end mt-2" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Contact = _resolveComponent("Contact")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "password-view container",
      onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (!_ctx.isValid ? _ctx.submit : undefined), ["enter"]))
    }, [
      _createVNode(_component_Breadcrumbs, {
        "class-name": "py-3 mt-1",
        "path-list": _ctx.pathList
      }, null, 8, ["path-list"]),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title-ssl-certificate-view text-start" }, [
        _createElementVNode("h2", { class: "fw-600" }, " Instalação de Certificado Digital Financeiro e SSL com CSR ")
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-12 col-md-6 d-none d-lg-block text-center" }, [
            _createElementVNode("img", {
              alt: "emitir-certificado",
              src: _imports_0
            })
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "description-password-view d-flex text-start" }, [
              _createElementVNode("p", { class: "fs-6" }, "Informe o nome do usuário e a senha de emissão")
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { for: "user" }, " Usuário * ", -1)),
                _createVNode(_component_Icon, {
                  id: "user-info-tooltip",
                  name: "circle-question",
                  class: "icon ms-2 align-text-bottom",
                  style: 'line-height: 1.65rem'
                })
              ]),
              _createVNode(_component_Input, {
                modelValue: _ctx.user,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user) = $event)),
                class: "mb-5",
                icon: "user",
                type: "text",
                "is-required": true,
                placeholder: "Ex: 01ED184010150778 11116521754247"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[5] || (_cache[5] = _createElementVNode("label", { for: "user" }, " Senha de emissão *", -1)),
                _createVNode(_component_Icon, {
                  id: "password-info-tooltip",
                  name: "circle-question",
                  class: "icon ms-2 align-text-bottom",
                  style: 'line-height: 1.65rem'
                })
              ]),
              _createVNode(_component_Input, {
                modelValue: _ctx.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                class: "mb-5",
                icon: "lock",
                type: "password",
                "is-required": true,
                placeholder: "Digite sua senha aqui",
                "error-log": _ctx.error
              }, null, 8, ["modelValue", "error-log"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                id: "next-step-button",
                class: _normalizeClass(["btn", [!_ctx.isValid ? 'btn-secondary' : 'btn-primary']]),
                type: "button",
                disabled: !_ctx.isValid,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("span", null, "Avançar", -1)),
                _createVNode(_component_Icon, {
                  class: "ms-2",
                  name: "arrow-right"
                })
              ], 10, _hoisted_9)
            ])
          ])
        ])
      ]),
      _createVNode(_component_Contact)
    ], 32),
    _createVNode(_component_Loading, { "is-loading": _ctx.isLoading }, null, 8, ["is-loading"])
  ], 64))
}